import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import '../edeeshop/jquery.fulltextAutocomplete';

export default class SectionSearch extends WebComponent {
  didMount() {
    const self = this;
    const autocompleteUrl = this.element.dataset.autocompleteUrl;
    this.element.querySelector('button').addEventListener('click', function(e) {
      self.element.querySelector('#query').remove();
      e.preventDefault();
      self.element.submit();
    });
    $(this.element).fulltextAutocomplete({
      url: `/qf/${window.projectConfig.lang}/ramjet/${autocompleteUrl}`,
      lang: window.projectConfig.lang,
      querySelector: '#sectionQuery',
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/components/SectionSearch.js